import React, { PureComponent } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import styled from 'styled-components';
import Button from '../../../components/SolvPatternLibrary/Button';
import { colors } from '../../../constants/colors';
import { fontSize, fontFamily } from '../../../constants/text';

const StyledDialog = styled(Dialog).withConfig({ componentId: 'sc-1yokdru-0' })`
  & .el-papel {
    margin: 24px;
  }
`;

const Title = styled(DialogTitle).withConfig({ componentId: 'sc-1yokdru-1' })`
  h2 {
    color: ${colors.squid};
    font-size: ${fontSize.large};
    font-family: ${fontFamily.medium};
    text-align: center;
  }
`;

const Actions = styled(DialogActions).withConfig({ componentId: 'sc-1yokdru-2' })`
  border-top: 1px solid ${colors.justAnotherGray};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 12px;
`;

const Content = styled(DialogContent).withConfig({ componentId: 'sc-1yokdru-3' })`
  color: ${colors.myRightFoot};
  text-align: center;
  font-size: ${fontSize.medium};
  p {
    margin: 0;
  }

  p:first-child {
    margin-bottom: 8px;
  }
`;

const RedButton = styled(Button).withConfig({ componentId: 'sc-1yokdru-4' })`
  color: ${colors.ladyInRed};
`;

type Props = {
  onClose?: (...args: any[]) => any;
  handleProfileDeletion?: (...args: any[]) => any;
  value?: string;
  userProfile?: any;
  open?: boolean;
};

class ConfirmationDialog extends PureComponent<Props> {
  render() {
    const userProfile = this.props.userProfile || {};
    const name = userProfile.is_verified
      ? `${userProfile.first_name} ${userProfile.last_name}`
      : 'Unverified';
    const warning = `Are you sure you want to delete ${name}'s profile?`;

    return (
      // @ts-expect-error ts-migrate(2769) FIXME: Property 'open' is missing in type '{ children: El... Remove this comment to see the full error message
      <StyledDialog
        aria-labelledby="confirmation-dialog-title"
        classes={{ paper: 'el-papel' }}
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="sm"
        {...this.props}
      >
        <Title id="confirmation-dialog-title">Remove Profile</Title>

        <Content>
          <p>{warning}</p>
          <p>This action cannot be undone.</p>
        </Content>

        <Actions>
          <Button onClick={this.props.onClose} text="CANCEL" variation="link" />

          <RedButton
            onClick={this.props.handleProfileDeletion}
            text="REMOVE PROFILE"
            variation="link"
          />
        </Actions>
      </StyledDialog>
    );
  }
}

export default ConfirmationDialog;
